const styles = {
  container: {
    height: "100%",
    width: "100px",
    position: "relative",
    marginRight: "5px",
    display: "inline-block",
    cursor: "pointer",
    float: "left",
    border: 0,
    background: "transparent",
  },
  media: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  mediaIcon: {
    position: "absolute",
    bottom: "8px",
    right: "8px",
  },
};

export default styles;
